<div class="loren-line-chart-wrapper">
  <apx-chart
    #chart
    [annotations]="chartOptions.annotations"
    [chart]="chartOptions.chart"
    [colors]="chartOptions.colors"
    [dataLabels]="chartOptions.dataLabels"
    [fill]="chartOptions.fill"
    [grid]="chartOptions.grid"
    [series]="chartOptions.series"
    [stroke]="chartOptions.stroke"
    [legend]="chartOptions.legend"
    [title]="chartOptions.title"
    [tooltip]="chartOptions.tooltip"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"></apx-chart>

  @if(chartData.length === 0) {
  <div class="pt-5 text-muted">
    {{ "chart.no_data_available" | transloco }}
  </div>
  } @if(showNotes && notes?.length) {
  <div class="container">
    <div class="row">
      <div class="col-sm pt-2 pb-4">
        <span class="strong font-weight-bold">{{
          "chart.time" | transloco
        }}</span>
      </div>
      <div class="col-sm pt-2 pb-4">
        <span class="strong font-weight-bold">{{
          "chart.note" | transloco
        }}</span>
      </div>
    </div>
    @for(point of notes; track point; let i = $index) {
    <div class="row">
      <div class="col-sm pt-2 pb-4">
        {{ i + 1 }}.
        {{ point.x | lorenDate }}
        ({{ point.objectName }})
      </div>
      @if(point.notes.length) {
      <div class="col-sm">
        <div class="pt-1 pb-2 text-break">
          <div>
            <span class="font-italic"
              >{{ point.notes[0]?.author }}
              {{ "chart.at" | transloco }}
              {{ $safeNavigationMigration(point.notes[0]?.createdOnFormatted) | lorenDate }}:</span
            >
            {{ point.notes[0]?.note }}
          </div>
          <button matButton="filled" (click)="clickNote(point)">
            {{ "operations.open_thread" | transloco }}
          </button>
        </div>
      </div>
      }
    </div>
    }
  </div>
  }
</div>
